<template>
    <img
        v-bind="$attrs"
        :style="styles"
        src="https://dev.teams.microsoft.com/hashed/e560eef2df218a593adcd028fb83a3e9.png"
    />
</template>

<script>
export default {
    name: 'teams-logo',
    inheritAttrs: false,
    props: {
        inline: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        styles() {
            var response = {}
            if (this.inline) {
                response['vertical-align'] = 'middle'
                response['display'] = 'inline-block'
            }
            return response
        }
    }
}
</script>

<style lang="scss" scoped></style>
